<template>
  <div class="house-importer-change-name-block">
    <div v-if="label.length" class="house-importer-change-name-block__label">
      {{label}}
    </div>

    <ChangeNameRow :new-label="newLabel"
                   :oldLabel="oldLabel"
                   class="house-importer-change-name-block__row"
                   v-for="(val, index) in model"
                   :key="index"
                   :ref="`house-importer-change-name-block__row[${index}]`"
                   @go-next-row="goNextRow(index)"
                   @go-prev-row="goPrevRow(index)"
                   :value="val"
                   @change="changeValue($event, index)"
    />
  </div>
</template>

<script>
  import ChangeNameRow from "./ChangeNameRow";

  export default {
    name: "ChangeNameBlock",
    components: {
      ChangeNameRow
    },
    props: {
      oldLabel: {},
      newLabel: {},
      label: {
        type: String,
        default: ""
      },
      value: {}
    },
    computed: {
      model: {
        get(){
          return this.value || [];
        },
        set(v){
          this.setValue(v);
        }
      }
    },
    methods: {
      setValue(v){
        this.$emit('input', v);
      },
      goNextRow(index){
        if(index === this.model.length - 1){
          this.addNewRow();
        }

        this.$nextTick(() => {
          let ref = this.$refs[`house-importer-change-name-block__row[${index+1}]`];
          if(ref && ref.length){
            ref[0].focusNewInput();
          }
        });
      },
      goPrevRow(index){
        if(index !== 0 && this.model[index] === '||=||'){
          this.deleteValue(index)
        }

        this.$nextTick(() => {
          let ref = this.$refs[`house-importer-change-name-block__row[${index-1}]`];
          if(ref && ref.length){
            ref[0].focusOldInput();
          }
        });
      },
      changeValue(val, index){
        let arrayValue = this.model;
        // arrayValue[index] = val;
        this.$set(arrayValue, index, val);
        this.$emit('input', arrayValue);

      },
      deleteValue(index){
        let arrayValue = this.model;
        arrayValue.splice(index, 1);
        this.$emit('input', arrayValue);
      },
      addNewRow(){
        this.model.push('||=||');
      },
    },
    mounted() {
      this.$nextTick(() => {
        this.addNewRow();
      });
    }
  }
</script>

<style lang="scss">
  .house-importer-change-name-block{

    &__label{
      color: #627084;
      font-size: 14px;
      display: block;
      text-align: center;
      margin-bottom: 20px;
    }


    &__row{
      margin-bottom: 15px;
    }
  }
</style>